import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroCarousel from './components/HeroCarousel';
import ComicRecommend from './components/ComicRecommend';
import NewsAndRanking from './components/NewsAndRanking';
import TopicSection from './components/TopicSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <title>漫蛙漫画动漫频道 - 最新动漫资讯与作品推荐</title>
      <meta
        name="description"
        content="漫蛙为您提供丰富的漫画动漫资源和最新资讯，涵盖多种类型作品，让动漫爱好者轻松浏览喜欢的漫画和动画内容。"
      />
      <meta name="keywords" content="漫蛙,漫画,动漫,动漫资讯,漫画推荐,动漫作品,漫画阅读,动漫频道" />

      <SiteHeader />

      <main className="flex-1">
        <HeroCarousel />

        <div className="bg-background-50 py-14">
          <div className="mx-auto w-full max-w-[1440px]">
            <ComicRecommend />
          </div>
        </div>

        <div className="bg-background-100 py-14">
          <div className="mx-auto w-full max-w-[1440px]">
            <NewsAndRanking />
          </div>
        </div>

        <div className="bg-background-50 py-14">
          <div className="mx-auto w-full max-w-[1440px]">
            <TopicSection />
          </div>
        </div>

        <div className="bg-background-100 py-14">
          <div className="mx-auto w-full max-w-[1440px]">
            <AboutSection />
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}